import { Link } from "react-router-dom";
import { SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";
import TopicsModal from "../modals/TopicsModal";
import { useState } from "react";
import { SubTopicObject, topics } from "assets/data/topics";

export type TopicsComponentProps = CustomComponentProps & {
    isPage?: boolean;
    selectedTopics: SubTopicObject[];
    toggleTopic: Function;
    handleHide?: Function;
};

const TopicsComponent = ({
    isPage = false,
    toggleTopic,
    selectedTopics,
    handleHide,
    className,
    style
}: TopicsComponentProps) => {
    const [openTopicModal, setOpenTopicModal] = useState(false);
    const [topicModalTitle, setTopicModalTitle] = useState("");
    const [topicModalSubTopics, setTopicModalSubTopics] = useState<
        SubTopicObject[]
    >([]);

    const handleOpenTopicModal = (
        title: string,
        subTopics: SubTopicObject[]
    ) => {
        setTopicModalTitle(title);
        setTopicModalSubTopics(subTopics);
        setOpenTopicModal(true);
    };

    return (
        <>
            <div
                className={`settings-page langs-container ${className}`}
                style={style}
            >
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    {isPage ? (
                        <Link to="/settings">
                            <SVG svg="chevron-left" size={24} />
                        </Link>
                    ) : (
                        <div onClick={() => handleHide && handleHide()}>
                            <SVG svg="chevron-left" size={24} />
                        </div>
                    )}
                    <h1 className="fw-700 fs-12em">Topics</h1>
                    <div></div>
                </div>
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <p className="momeento-p">
                        You can select up to four topics to explore your posts
                        and incidents to all users who's intersting topics you
                        selected.
                    </p>
                </div>

                <div className="card pl-10 pr-10 pt-10 pb-10">
                    <div className="form-panel">
                        <div
                            className={`fieldd mb-30 ${selectedTopics.length ? "" : "is-hidden"}`}
                            id="choosen-topics-field"
                        >
                            <div className="topic-head d-flex flex-j-between gap-10 pt-10 pb-15">
                                <h2 className="white-text">Choosen Topics</h2>
                                <div className="tooltip">
                                    <div className="momeento-svg info-svg svg-18"></div>
                                    <span className="tooltiptext momeento-p">
                                        You can select up to four topics to
                                        explore your posts and incidents to all
                                        users who's intersting topics you
                                        selected.
                                    </span>
                                </div>
                            </div>
                            <ul
                                className="ks-cboxtags topic-body d-flex flex-wrap flex-j-start gap-5"
                                id="choosen-topics-ul"
                            >
                                {selectedTopics.map((topic) => (
                                    <li
                                        key={topic.SubTopicId}
                                        className="checked"
                                        onClick={() => toggleTopic(topic)}
                                    >
                                        <label>{topic.Name}</label>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div
                            className="topics-form-panel pr-10"
                            id="topics-form-panel"
                        >
                            {topics.map((t) => (
                                <div className="field" key={t.TopicId}>
                                    <div className="topic-head d-flex flex-j-between gap-10 pt-10 pb-10">
                                        <h2 className="white-text">{t.Name}</h2>
                                        {t.SubTopics.length > 6 ? (
                                            <a
                                                className="button modal-trigger"
                                                onClick={() =>
                                                    handleOpenTopicModal(
                                                        t.Name,
                                                        t.SubTopics
                                                    )
                                                }
                                            >
                                                View More
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <ul className="ks-cboxtags topic-body d-flex flex-wrap flex-j-start gap-5">
                                        {t.SubTopics.slice(0, 6).map(
                                            (topic) => (
                                                <li
                                                    key={topic.SubTopicId}
                                                    onClick={() =>
                                                        toggleTopic(topic)
                                                    }
                                                    className={
                                                        selectedTopics.some(
                                                            (t) =>
                                                                t.SubTopicId ==
                                                                topic.SubTopicId
                                                        )
                                                            ? "checked"
                                                            : ""
                                                    }
                                                >
                                                    <label>{topic.Name}</label>
                                                </li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <TopicsModal
                opened={openTopicModal}
                closeModal={setOpenTopicModal}
                selectedTopics={selectedTopics}
                toggleTopic={toggleTopic}
                title={topicModalTitle}
                subTopics={topicModalSubTopics}
            />
        </>
    );
};

export default TopicsComponent;
